import { useTranslation } from "react-i18next";
import { Tooltip } from "@components/Tooltip/Tooltip";
import { isNullOrUndefined } from "@utils/common";
import { formatPrice } from "@utils/units";

interface ICalculatedAmountProps {
  totalAmount?: number;
  currency: string;
  totalSum: number;
}

export const CalculatedAmount: React.FC<ICalculatedAmountProps> = ({
  totalAmount,
  currency,
  totalSum,
}) => {
  const { t } = useTranslation();

  return (
    !isNullOrUndefined(totalSum) &&
    totalSum !== totalAmount && (
      <div className="whitespace-nowrap text-sm md:text-base">
        <Tooltip content={t("bill.calculatedAmount.tooltip")}>
          <span className="text-grey-dark">
            {`${t("bill.calculatedAmount.title")}: `}
          </span>
          <span className="font-medium text-base-red">
            {formatPrice(totalSum, { currency })}
          </span>
        </Tooltip>
      </div>
    )
  );
};
